import axios from 'axios';
import store from '../store';

store.subscribe(listener);

function select(state){
  return state.auth.jwtToken
}

function listener(){
  let token = select(store.getState());
  axios.defaults.headers.common['Authorization'] = 'Bearer '+token;
}

export const userModelServer = axios.create({
  baseURL: 'https://user.themusio.com/',
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 10000
});

export const edgeServer = axios.create({
  baseURL: 'https://edge-api.themusio.com/v1/',
  headers:{
    'Content-Type': 'application/json'
  },
  timeout: 10000
});

export const edgeTestServer = axios.create({
  baseURL: 'https://edge-test-api.themusio.com/v1/',
  headers:{
    'Content-Type': 'application/json'
  },
  timeout: 10000
});

export let eduServer = axios.create({
  baseURL: 'https://edu-api.themusio.com/dev/',
  headers:{
    'Content-Type': 'application/json'
  },
  timeout: 10000
});



// WEBPACK FOOTER //
// ./src/api_client/apiClient.js